<template>
  <div class="my-chat-message">
    <div>{{ message.content }}</div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: Object,
    },
  },
};
</script>

<style lang="scss" scoped>
.my-chat-message {
  text-align: right;
  padding: 16px;

  div {
    display: inline-block;
    text-align: left;
    max-width: 360px;
    padding: 12px;
    border-radius: 16px 16px 0px 16px;
    color: #000;
    background: var(--primary-button-bg);
    word-break: break-word;
  }
}
</style>
